// Theme
import { colors } from './colors';

export const borders = {
  void: `solid 1px`,
  tooltip: `solid 1px ${colors.border[100]}`,
  section: `solid 1px ${colors.border[100]}`,
  selected: `solid 1px ${colors.tealishBlue}`,
  selectedDate: `solid 1px ${colors.tealishBlue[100]}`,
  selectedStrong: `solid 2px ${colors.tealishBlue}`,
  active: `solid 3px ${colors.base}`,
  blueCheck: `solid 1px ${colors.submitScheme[500]}`,
  greyCheck: `solid 1px ${colors.grey[20]}`,
  greyLight: `solid 1px ${colors.grey[10]}`,
  light: `solid 1px ${colors.border[50]}`,
  activeDashed: `2px dashed ${colors.base}`,
  baseDashed: `2px dashed ${colors.grey[20]}`,
  lightWhite: `solid 1px ${colors.lightWhite}`,
  greyDark: `solid 1px ${colors.grey[100]}`,
  primaryPurple: `solid 1px ${colors.linkWater}`,
};

const dialogerRadius = '0.5rem';

export const borderRadius = {
  dialogerRadius,
  dialogerBodyRadius: `0 0 ${dialogerRadius} ${dialogerRadius}`,
  dialogerRadiusTop: `0 0 ${dialogerRadius} ${dialogerRadius}`,
  dialogerRadiusRight: `${dialogerRadius} 0 0 ${dialogerRadius}`,
  dialogerRadiusBottom: `${dialogerRadius} ${dialogerRadius} 0 0`,
  dialogerRadiusLeft: `0 ${dialogerRadius} ${dialogerRadius} 0`,
};
